import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Image from "next/image";

interface FlightCardAirlineInfoProps {
  name: string;
  logo?: string | null;
  flightNumber: string;
  classType: string;
}

export default function FlightCardAirlineInfo({
  name,
  logo,
  flightNumber,
  classType,
}: FlightCardAirlineInfoProps) {
  return (
    <Flex alignItems={"center"} gap={"1"}>
      {logo && (
        <Flex.Item>
          <Image src={logo} alt={name} width={46} height={46} />
        </Flex.Item>
      )}

      <Flex.Item>
        <Flex direction={"col"} gap={"1"}>
          <Typography variant={"body1"}>{name}</Typography>
          <Flex gap={"2"}>
            <Typography
              variant={"caption"}
              className="text-grayColor-foreground"
            >
              {flightNumber}
            </Typography>
            <Typography
              variant={"caption"}
              className="text-grayColor-foreground"
            >
              {classType}
            </Typography>
          </Flex>
        </Flex>
      </Flex.Item>
    </Flex>
  );
}
